export enum QueryKeys {
  fetchUsers = "fetchUsers",
  fetchApps = "fetchApps",
}
